// extracted by mini-css-extract-plugin
export default {"divider":"Divider_divider__g3ghB","light":"Divider_light__+vGa0","dark":"Divider_dark__jtC2w"};